import {
  faCar,
  faCarSide,
  faCheckCircle,
  faCheckDouble,
  faClipboardCheck,
  faClock,
  faPhone,
  faTag,
  faWrench,
  faCarGarage,
  faTimes,
  faUserCheck,
  faExclamationTriangle,
  faDollarSign,
  faShieldCheck,
  faCalendarCheck,
} from "@fortawesome/pro-solid-svg-icons";
import { faSmile } from "@fortawesome/pro-regular-svg-icons";

import { APPOINTMENT_STATUSES } from "../../../../../util/common";
import { faSquareA, faCircleQuarterStroke } from "./customIcons";

const COLOR_GREEN = "#21ba45";

export const STATUS_ICON_CONFIG = {
  [APPOINTMENT_STATUSES.CANCELED]: { icon: faTimes, color: COLOR_GREEN, translationKey: "cc_canceled", fallbackTranslation: "Canceled" },
  [APPOINTMENT_STATUSES.NEW_CAR]: { icon: faCar, color: COLOR_GREEN, translationKey: "cc_new_car", fallbackTranslation: "New Car" },
  [APPOINTMENT_STATUSES.CAR_CHECK]: { icon: faWrench, color: COLOR_GREEN, translationKey: "cc_car_check", fallbackTranslation: "Car Check" },
  [APPOINTMENT_STATUSES.PRICING_OK]: { icon: faTag, color: COLOR_GREEN, translationKey: "cc_pricing_ok", fallbackTranslation: "Pricing OK" },
  [APPOINTMENT_STATUSES.CUSTOMER_OK]: { icon: faSmile, color: COLOR_GREEN, translationKey: "cc_proposal_ok", fallbackTranslation: "Proposal OK" },
  [APPOINTMENT_STATUSES.CAR_READY]: { icon: faCheckDouble, color: COLOR_GREEN, translationKey: "cc_car_ready", fallbackTranslation: "Car Ready" },
  [APPOINTMENT_STATUSES.DIAGNOSE]: { icon: faExclamationTriangle, color: COLOR_GREEN, translationKey: "cc_diagnose", fallbackTranslation: "Diagnose" },
  [APPOINTMENT_STATUSES.AANNAME_OK]: { icon: faSquareA, color: COLOR_GREEN, translationKey: "cc_initial_check_done", fallbackTranslation: "Initial Check Done" },
  [APPOINTMENT_STATUSES.CALCULATING]: { icon: faDollarSign, color: COLOR_GREEN, translationKey: "cc_calculating", fallbackTranslation: "Calculating" },
  [APPOINTMENT_STATUSES.CONTACT]: { icon: faPhone, color: COLOR_GREEN, translationKey: "cc_contact", fallbackTranslation: "Contact" },
  [APPOINTMENT_STATUSES.CAR_CHECK_STARTED]: { icon: faCircleQuarterStroke, color: COLOR_GREEN, translationKey: "cc_car_check_started", fallbackTranslation: "Car Check Started" },
  [APPOINTMENT_STATUSES.QUALITY_CHECK]: { icon: faShieldCheck, color: COLOR_GREEN, translationKey: "cc_quality_check", fallbackTranslation: "Quality Check" },
  [APPOINTMENT_STATUSES.CUSTOMER_ANSWERED]: { icon: faUserCheck, color: COLOR_GREEN, translationKey: "cc_customer_answered", fallbackTranslation: "Customer Answered" },
  [APPOINTMENT_STATUSES.BACK_ORDER]: { icon: faClock, color: COLOR_GREEN, translationKey: "cc_back_order", fallbackTranslation: "Back Order" },
  [APPOINTMENT_STATUSES.HANDLE_CHECK_IN]: { icon: faCalendarCheck, color: COLOR_GREEN, translationKey: "cc_handle_check_in", fallbackTranslation: "Handle Check-In" },
  [APPOINTMENT_STATUSES.CHECK_IN_DONE]: { icon: faClipboardCheck, color: COLOR_GREEN, translationKey: "cc_check_in_done", fallbackTranslation: "Check-In Done" },
  [APPOINTMENT_STATUSES.CAR_IN_SHOP]: { icon: faCarGarage, color: COLOR_GREEN, translationKey: "cc_car_in_shop", fallbackTranslation: "Car in Shop" },
  [APPOINTMENT_STATUSES.CAR_OK_PLUS_REPAIR_OVERVIEW]: {
    icon: faCheckCircle,
    color: COLOR_GREEN,
    translationKey: "cc_car_ok_plus_repair_overview",
    fallbackTranslation: "Car OK + Repair Overview",
  },
  [APPOINTMENT_STATUSES.QUALITY_CHECK_PLUS_REPAIR_OVERVIEW]: {
    icon: faClipboardCheck,
    color: COLOR_GREEN,
    translationKey: "cc_quality_check_plus_repair_overview",
    fallbackTranslation: "Quality Check + Repair Overview",
  },
  [APPOINTMENT_STATUSES.CAR_OUT_OF_SHOP]: { icon: faCarSide, color: COLOR_GREEN, translationKey: "cc_car_out_of_shop", fallbackTranslation: "Car Out of Shop" },
};

const DEFAULT_STATUS_ICON_CONFIG = { icon: null, color: COLOR_GREEN, translationKey: "", fallbackTranslation: "" };

export const getStatusIconConfig = identifier => STATUS_ICON_CONFIG[identifier] || DEFAULT_STATUS_ICON_CONFIG;

export const getStatusByIdentifier = (identifier, locationStatuses) => {
  if (!locationStatuses) return null;
  return locationStatuses.find(s => s.identifier === identifier) || null;
};

export const getStatusName = (identifier, locationStatuses, t) => {
  const match = getStatusByIdentifier(identifier, locationStatuses);
  if (match?.name) return match.name;

  const cfg = getStatusIconConfig(identifier);
  if (!cfg.translationKey) return "";
  return t(cfg.translationKey).message || cfg.fallbackTranslation;
};
